import { load } from "../../../pages/table/_page.server.js";
import "path";
async function GET(event) {
  return new Response(JSON.stringify(await load(event)));
}
export {
  GET
};
